import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: {base: remCalc(40), lg: remCalc(80)},
            width: '100%',
        },
        middleContainer: {
            width: '100%',
            borderBottom: 'small',
            borderColor: 'border.light',
            paddingBottom: {base: remCalc(24), lg: remCalc(40)},
        },
        innerContainer: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: remCalc(26),
            alignSelf: 'stretch',
            maxWidth: remCalc(1044),
        },
        image: {
            width: {base: remCalc(109), lg: remCalc(358)},
            height: {base: remCalc(109), lg: '100%'},
            objectFit: 'contain',
            alignSelf: 'stretch',
        },
        horizontalDivider: {
            color: 'border.light',
            display: 'block',
        },
        button: {
            display: 'flex',
            minHeight: remCalc(40),
            minWidth: remCalc(140),
            width: remCalc(332),
            padding: `${remCalc(18)} ${remCalc(24)}`,
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'stretch',
            border: null,
            borderColor: 'dark',
            borderStyle: 'solid',
            background: 'button.background.primary-default',
        },
        buttonText: {
            textStyle: 'body-medium',
            fontWeight: 'bold',
        },
        buttonContainer: {
            display: 'flex',
            height: '40px',
            justifyContent: ['center', 'center', 'center', 'flex-end'],
            alignItems: 'center',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
        formContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            flex: '1 0 0',
        },
        titleText: {
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
            color: 'text.default',
            mb: [remCalc(10), remCalc(10), remCalc(10), 0],
        },
        titleOuterContainer: {
            flexDirection: 'column',
            gap: {base: remCalc(26), lg: remCalc(16)},
        },
        titleInnerContainer: {
            flexDirection: 'column',
            gap: remCalc(16),
        },
        registrationFormSubtitle: {
            textStyle: 'body-small',
        },
        registrationFormSubtitleDescription: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        detailText: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.default',
        },
        purchaseText: {
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
            maxWidth: remCalc(360),
        },
        linkText: {
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        skuNumberContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        formInnerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
        },
        uploadFileContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        fileNameContainer: {
            display: 'flex',
            width: '100%',
            minWidth: 0,
            minHeight: 'var(--chakra-sizes-input-xl-height)',
            paddingX: 'var(--chakra-sizes-input-xl-paddingX)',
            paddingY: 'var(--chakra-sizes-input-xl-paddingY)',
            alignItems: 'center',
            alignSelf: 'stretch',
            gap: remCalc(8),
            borderRadius: 'large-1',
            border: '1px solid var(--chakra-colors-border-neutral-highlight)',
            background: 'background.neutral.default',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'foreground.neutral.subtle',
            '&[data-has-file=true]': {
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-positive-md), 0 0 0 1px var(--chakra-shadows-positive-xl), 0 0 0 4px var(--chakra-shadows-positive-xs)',
            },
        },
        fileNameLabel: {
            minWidth: 0,
            overflowWrap: 'anywhere',
        },
        fileUploadErrorMessage: {
            width: '100%',
            alignItems: 'center',
            alignSelf: 'stretch',
            borderColor: 'border.secondary',
            background: 'background.default',
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            color: 'text.danger',
            marginTop: remCalc(4),
        },
        fileButton: {
            minWidth: remCalc(140),
        },
    },
    variants: {
        editRegisteredProductForm: {
            outerContainer: {
                gap: {base: remCalc(24)},
            },
            buttonContainer: {
                justifyContent: 'flex-start',
                flexDirection: {base: 'column', lg: 'row'},
                height: {base: 'auto', lg: remCalc(40)},
                gap: {base: remCalc(16), lg: remCalc(24)},
            },
            formButton: {
                display: 'flex',
                width: {base: '100%', lg: remCalc(332)},
                minWidth: remCalc(140),
                maxHeight: remCalc(40),
                padding: `${remCalc(18)} ${remCalc(24)}`,
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: remCalc(100),
                border: null,
                borderStyle: 'solid',
            },
            formButtonSecondary: {
                display: 'flex',
                width: {base: '100%', lg: remCalc(332)},
                minWidth: remCalc(140),
                maxHeight: remCalc(40),
                padding: `${remCalc(18)} ${remCalc(24)}`,
                justifyContent: 'center',
                alignItems: 'center',
                background: 'button.background.secondary-default',
                borderRadius: remCalc(100),

                buttonText: {
                    color: 'button.text.secondary-default',
                },
            },
            buttonText: {
                textStyle: 'body-small',
                fontWeight: 'medium',
            },
        },
    },
    parts: ['registrationFormSubtitle', 'registrationFormSubtitleDescription'],
}
